import * as Types from '../constants/Types';
import Tour, { TourTicket } from '../models/Tour';
import { PAGINATION } from '../constants/Define';
import { updateObjectInArray, getMomentDate } from '../utils/commonUtils';
import moment from "moment";
import { findIndex } from 'lodash';
import TagSKUVW from 'containers/backend/layout/Tours/TourDetail/TourTabs/Generalnfo/TagSKUVW';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    isFetchingTicket: false,
    isTourTypeFetching: false,
    isTourSurchargeCategoriesFetching: false,
    isTourLineFetching: false,
    isTourLineTicketFetching: false,
    isFetchingDownload: false,
    isFetching: false,
    isFetched: false,
    isTagsSKUVWFetching: false,
    tours: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    orderBy: undefined,
    orderByDesc: false,
    searchTerm: undefined,
    departure: undefined,
    destination: undefined,
    departureDate: undefined,
    fromDate: undefined,
    toDate: undefined,
    priceFrom: undefined,
    priceTo: undefined,
    lengthOfTour: undefined,
    isShowBulkCreate: false,
    detail: {
        tour: new Tour(),
        tourLines: [],
        tourLineParams: {
            fromDate: moment().startOf('month').add(1, 'days'),
            toDate: moment().endOf('month'),
        },
        tourLineDateRanges: [],
        tourLineTickets: [],
    },
    tourTypes: [],
    tourSurchargeCategories: [],
    allTours: [],
    tourLine: {},
    tourTicketData: {},
    tourTicketDetail: {
        isSuccessfulUpdated: false,
        isFetching: false,
        tourTicket: new TourTicket(),
    },
    tagsSKUVW: [],
};

const setTourLineTicket = (tourLines, tourlined, itemTickets) => {
    const dataTourLine = [...tourLines]
    const tourIndex = findIndex(dataTourLine, item => item.id === tourlined);
    if (tourIndex !== -1) {
        dataTourLine[tourIndex].tickets = itemTickets
    }
    return dataTourLine
}

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TOUR_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_LINE_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_LINE_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_LINE_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.tours, isSubmit: false };
        case Types.TOUR_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate, isSubmit: false };
        case Types.TOUR_LINE_DELETE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.TOUR_LINE_CREATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.TOUR_LINE_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.MULTIPLE_TOUR_LINE_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true, isShowModal: true };
        case Types.MULTIPLE_TOUR_LINE_CREATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false, isShowModal: false };
        case Types.TOUR_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isSubmit: false, isShowModal: true };

        //export
        case Types.TOUR_EXPORT_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.TOUR_EXPORT_EXCEL_SUCCESS:
            return { ...state, isFetchingDownload: false }
        case Types.TOUR_EXPORT_EXCEL_FAIL:
            return { ...state, isFetchingDownload: false }

        // NEW TOUR PROCESS:
        case Types.TOUR_GET_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_GET_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                tours: action.tours,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
                ...action.params,
            };
        case Types.TOUR_GET_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, tours: [] };
        case Types.TOUR_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.TOUR_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { ...state.detail, tour: action.tour }
            };
        case Types.TOUR_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        //TOUR TYPES
        case Types.TOUR_TYPE_GET_ALL_ACTION:
            return { ...state, isTourTypeFetching: true };
        case Types.TOUR_TYPE_GET_ALL_SUCCESS:
            return {
                ...state,
                isTourTypeFetching: false,
                tourTypes: action.tourTypes,
            };
        case Types.TOUR_TYPE_GET_ALL_FAIL:
            return { ...state, isTourTypeFetching: false, tourTypes: [] };
        case Types.TOUR_TYPE_DETAIL_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_TYPE_DETAIL_SUCCESS:
            return {
                ...state,
                isTourTypeFetching: false, isFetched: true,
                tourTypes: updateObjectInArray(action.tourType, state.tourTypes),
            };
        case Types.TOUR_TYPE_DETAIL_UPDATE_ACTION:
            return { ...state, isTourTypeFetching: true };
        case Types.TOUR_TYPE_DETAIL_CREATE_ACTION:
            return { ...state, isTourTypeFetching: true };
        case Types.TOUR_TYPE_DETAIL_DELETE_ACTION:
            return { ...state, isTourTypeFetching: true };
        case Types.TOUR_TYPE_DETAIL_DELETE_SUCCESS:
            return { ...state, isTourTypeFetching: false, tourTypes: state.tourTypes.filter(item => item.id !== action.id) };
        case Types.TOUR_TYPE_DETAIL_FAIL:
            return { ...state, isTourTypeFetching: false };

        // TOUR SURCHARGE CATEGORIES
        case Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_ACTION:
            return { ...state, isTourSurchargeCategoriesFetching: true };
        case Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_SUCCESS:
            return {
                ...state,
                isTourSurchargeCategoriesFetching: false,
                tourSurchargeCategories: action.surchargeCategories,
            };
        case Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_FAIL:
            return { ...state, isTourSurchargeCategoriesFetching: false, tourTypes: [] };
        case Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_CREATE_ACTION:
            return { ...state, isTourSurchargeCategoriesFetching: true };
        case Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_FAIL:
            return { ...state, isTourSurchargeCategoriesFetching: false };


        // TOUR LINES
        case Types.TOUR_LINE_GET_LIST_ACTION:
            return { ...state, isTourLineFetching: true, detail: { ...state.detail, tourLines: [] } };
        case Types.TOUR_LINE_GET_LIST_SUCCESS:
            return {
                ...state,
                isTourLineFetching: false,
                detail: {
                    ...state.detail,
                    tourLines: action.tourLines,
                    tourLineParams: {
                        ...state.detail.tourLineParams,
                        tourItemId: undefined,
                        tourTicketId: undefined,
                        tourTicketIds: action.tourTicketIds,
                        fromDate: getMomentDate(action.fromDate),
                        toDate: getMomentDate(action.toDate),
                    },
                    tourLineDateRanges: action.tourLineDateRanges,
                },
            };
        case Types.TOUR_LINE_GET_LIST_FAIL:
            return { ...state, isTourLineFetching: false };
        case Types.TOUR_LINE_DETAIL_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_LINE_DETAIL_SUCCESS:
            return {
                ...state,
                isTourLineFetching: false, isFetched: true,
                detail: { ...state.detail, tourLines: updateObjectInArray(action.tourLine, state.detail.tourLines) }
            };
        case Types.TOUR_LINE_DETAIL_UPDATE_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_LINE_DETAIL_CREATE_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_LINE_BULK_CREATE_ACTION:
        case Types.TOUR_LINE_BULK_UPDATE_ACTION:
        case Types.TOUR_LINE_BULK_DELETE_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_LINE_DETAIL_DELETE_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TOUR_LINE_DETAIL_DELETE_SUCCESS:
            return { ...state, isTourLineFetching: false, detail: { ...state.detail, tourLines: state.detail.tourLines.filter(item => item.id !== action.id) } };
        case Types.TOUR_LINE_DETAIL_FAIL:
        case Types.TOUR_LINE_BULK_CREATE_FAIL:
        case Types.TOUR_LINE_BULK_UPDATE_FAIL:
        case Types.TOUR_LINE_BULK_DELETE_FAIL:
            return { ...state, isTourLineFetching: false };
        case Types.TOUR_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_ITEM_TICKET_GET_ACTION:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_LIST_ACTION:
            return { ...state, isTourLineTicketFetching: true };
        case Types.TOUR_ITEM_TICKET_GET_SUCCESS:
            const tourLines = setTourLineTicket(state.detail.tourLines, action.tourlineId, action.itemTickets)
            return {
                ...state,
                isTourLineTicketFetching: true,
                detail: {
                    ...state.detail,
                    tourLines
                }
            };
        case Types.TOUR_ITEM_MODAL_BULK_ACTION:
            return {
                ...state,
                isShowBulkCreate: action.isOpen
            }
        case Types.TOUR_LIST_ALL_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_LIST_ALL_SUCCESS:
            return { ...state, isFetchingUpdate: false, allTours: action.allTours, isSubmit: false };
        case Types.TOUR_LINE_TICKET_GET_ACTION:
            return { ...state, isTourLineFetching: true, detail: { ...state.detail, tourLineTickets: [] } };
        case Types.TOUR_LINE_TICKET_GET_SUCCESS:
            return {
                ...state,
                isTourLineFetching: false,
                detail: {
                    ...state.detail,
                    tourLineTickets: action.tourLineTickets
                },
            };
        case Types.DETAIL_TOUR_TICKET_GET_ACTION:
            return { ...state, isFetchingTicket: true };
        case Types.DETAIL_TOUR_TICKET_GET_SUCCESS:
            return { ...state, isFetchingTicket: false, tourTicketData: action.data };
        case Types.DETAIL_TOUR_TICKET_DETAIL_CREATE_ACTION:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: true } };
        case Types.DETAIL_TOUR_TICKET_FAIL:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: false, isSuccessfulUpdated: false } };
        case Types.DETAIL_TOUR_TICKET_DETAIL_ACTION:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: true, isSuccessfulUpdated: false } };
        case Types.DETAIL_TOUR_TICKET_DETAIL_SUCCESS:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: false, tourTicket: action.tourTicket, isSuccessfulUpdated: true } };
        case Types.DETAIL_TOUR_TICKET_DETAIL_FAIL:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: false, isSuccessfulUpdated: false } };
        case Types.DETAIL_TOUR_TICKET_DETAIL_UPDATE_ACTION:
            return { ...state, isFetchingTicket: false, tourTicketDetail: { ...state.tourTicketDetail, isFetching: true, isSuccessfulUpdated: false } };

        // SKUTagsVW
        case Types.TAGSKUVW_GET_ALL_ACTION:
            return { ...state, isTagsSKUVWFetching: true };
        case Types.TAGSKUVW_GET_ALL_SUCCESS:
            return {
                ...state,
                isTagsSKUVWFetching: false,
                tagsSKUVW: action.tagSKUVW,
            };
        case Types.TAGSKUVW_GET_ALL_FAIL:
            return { ...state, isTagsSKUVWFetching: false, tagsSKUVW: [] };
        case Types.TAGSKUVW_DETAIL_ACTION:
            return { ...state, isTourLineFetching: true };
        case Types.TAGSKUVW_DETAIL_SUCCESS:
            return {
                ...state,
                isTagsSKUVWFetching: false, isFetched: true,
                tagsSKUVW: updateObjectInArray(action.tagSKUVW, state.tagsSKUVW),
            };
        case Types.TAGSKUVW_DETAIL_UPDATE_ACTION:
            return { ...state, isTagsSKUVWFetching: true };
        case Types.TAGSKUVW_DETAIL_CREATE_ACTION:
            return { ...state, isTagsSKUVWFetching: true };
        case Types.TAGSKUVW_DETAIL_DELETE_ACTION:
            return { ...state, isTagsSKUVWFetching: true };
        case Types.TAGSKUVW_DETAIL_DELETE_SUCCESS:
            return { ...state, isTagsSKUVWFetching: false, tagsSKUVW: state.tagsSKUVW.filter(item => item.id !== action.id) };
        case Types.TAGSKUVW_DETAIL_FAIL:
            return { ...state, isTagsSKUVWFetching: false };
        default:
            return state;
    }
}
